export const HELP_LOCATION_DEFAULT = 'https://google.com'
export const HELP_LOCATION_LINUX = 'https://help.ubuntu.com/stable/ubuntu-help/privacy-location.html'
export const HELP_LOCATION_MAC =
  'https://support.apple.com/en-sg/guide/mac-help/mh35873/mac#:~:text=use%20Location%20Services-,On%20your%20Mac%2C%20choose%20Apple%20menu%20%3E%20System%20Settings%2C%20click,may%20need%20to%20scroll%20down.)&text=Turn%20Location%20Services%20on%20or,the%20list%20on%20the%20right.'
export const HELP_LOCATION_WINDOWS =
  'https://support.microsoft.com/en-us/windows/windows-location-service-and-privacy-3a8eee0a-5b0b-dc07-eede-2a5ca1c49088'
